import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  min-height: 40px;
  padding: 8px 8px 8px 16px;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  background: ${({ theme }) => theme.colors.white};
  transition: all 0.2s ease-in-out;

  :hover {
    border-color: ${({ theme }) => theme.colors.green6};
  }

  :focus-within {
    border-color: ${({ theme }) => theme.colors.green6};
    box-shadow: 0px 0px 1px 2px ${({ theme }) => theme.colors.green2};
  }
`;

export const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
`;

export const TitleWrapper = styled.div`
  font-size: 14px;
  font-weight: 600;
`;

export const FormulaWrapper = styled.div`
  display: flex;
`;
